/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Unstar_AriaInputs */



/**
* | output |
* | --- |
* | "Unstar Record" |
*
* @param {Explorer_Info_Unstar_AriaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_unstar_aria = /** @type {((inputs?: Explorer_Info_Unstar_AriaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Unstar_AriaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Retirer des favoris")
	if (locale === "de") return /** @type {LocalizedString} */ ("Unstar Record")
	if (locale === "it") return /** @type {LocalizedString} */ ("Record non contrassegnato")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Unstar Record")
	if (locale === "es") return /** @type {LocalizedString} */ ("Registro sin estrella")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("不星唱片")
	if (locale === "ja") return /** @type {LocalizedString} */ ("スターなしレコード")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अनस्टार रिकॉर्ड")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Unstar Record")
	return /** @type {LocalizedString} */ ("Unstar Record")
});